export default {
    "bottom": "bottom",
    "center": "center",
    "middle": "middle",
    "left": "left",
    "right": "right",
    "top": "top"
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-popup-common/dist/es/align-point.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/align-point.js
// module chunks = vendor